import * as React from 'react'
import PropTypes from 'prop-types'

import { DASHBOARD_URL, HELP_URL } from '../../../models/Eventplanner'
import { getLogoutUrl } from '../../../models/Auth'

import { MobileMenu, ButtonInnerContent, RequestsUnreadCountWrapper } from './style'

import HeaderMenuMobileWrapper from '../../../components/header-menu-mobile-wrapper'
import HeaderMenuList from '../../../ui/header-menu-list'
import HeaderMenuItem from '../../../ui/header-menu-list-item'
import HeaderMenuButton from '../../../ui/header-menu-button'
import { SearchIcon } from '../../../icons'
import HeaderMenuSpacer from '../../../ui/header-menu-list-item-spacer'
import { shutdownIntercom } from './util'
import HeaderMenuItemUserMobile from '../../header-menu-item-user-mobile'
import GigRequestUnreadCount from '../../gig-request-unread-count'

const EventplannerMobileMenu = ({ artistRequestCount }) => (
  <MobileMenu>
    <HeaderMenuMobileWrapper forEventplanner>
      <HeaderMenuList inDropdown>
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton inDropdown to="/">
            Hjem
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuItemUserMobile />
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton inDropdown to={DASHBOARD_URL}>
            <ButtonInnerContent>
              Forespørsler
              <RequestsUnreadCountWrapper inDropdown>
                <GigRequestUnreadCount forEventplanner />
              </RequestsUnreadCountWrapper>
            </ButtonInnerContent>
          </HeaderMenuButton>
        </HeaderMenuItem>
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton to={HELP_URL} title="Gå til hjelp" aria-label="Gå til hjelp" inDropdown>
            Hjelp
          </HeaderMenuButton>
        </HeaderMenuItem>
        {artistRequestCount > 0 ? (
          <HeaderMenuItem inDropdown>
            <HeaderMenuButton inDropdown to="/controlpanel">
              Bytt til artist
            </HeaderMenuButton>
          </HeaderMenuItem>
        ) : null}
        <HeaderMenuSpacer />
        <HeaderMenuItem inDropdown>
          <HeaderMenuButton
            inDropdown
            onClick={shutdownIntercom}
            href={getLogoutUrl()}
            title="Logg ut"
            aria-label="Logg ut"
          >
            Logg ut
          </HeaderMenuButton>
        </HeaderMenuItem>
      </HeaderMenuList>
    </HeaderMenuMobileWrapper>
    <HeaderMenuList>
      <HeaderMenuItem>
        <HeaderMenuButton to="/s" title="Gå til søk" aria-label="Gå til søk">
          <SearchIcon height={30} width={30} />
        </HeaderMenuButton>
      </HeaderMenuItem>
    </HeaderMenuList>
  </MobileMenu>
)

EventplannerMobileMenu.propTypes = {
  artistRequestCount: PropTypes.number.isRequired,
}
EventplannerMobileMenu.defaultProps = {}

export default EventplannerMobileMenu
